import { defineStyleConfig } from "@chakra-ui/react";

const Menu = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    list: {
      color: "secondary.100",
      borderRadius: "xl",
      padding: 0,
      overflow: "hidden",
    },

    groupTitle: {
      bg: "transparent",
      textTransform: "uppercase",
      letterSpacing: "0.2em",
      fontSize: "xs",
      color: "secondary.500",
    },

    item: {
      bg: "secondary.600",
      px: 6,
      py: 3,
      _hover: {
        color: "secondary.50",
        bg: "secondary.500",
      },
      _focus: {
        color: "secondary.50",
        bg: "secondary.500",
      },
    },
  },
});

export default Menu;
